import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SystemHealthConnectivity } from '@shared/models';
import { TranslateService } from '@ngx-translate/core';

import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'gea-hrt-connectivity-status',
  standalone: true,
  imports: [TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @let status = connectivity();
    @if (status?.component === 'Panel') {
      <span class="status {{ status!.signalStatus.isAvailable ? 'available' : 'unavailable' }}" [pTooltip]="text()"> </span>
    }
  `,

  styles: `
    .status {
      height: 25px;
      width: 25px;
      border-radius: 50%;
      display: block;
    }
    .unavailable {
      background-color: red;
    }
    .available {
      background-color: green;
    }
  `,
})
export class ConnectivityStatusComponent {
  readonly translateService = inject(TranslateService);
  private readonly languageChange = toSignal(this.translateService.onLangChange, { initialValue: null });

  readonly connectivity = input<SystemHealthConnectivity>();

  readonly text = computed(() => {
    this.languageChange();

    const options: Intl.DateTimeFormatOptions = {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    };
    const noSignals = this.translateService.instant('SYSTEM_HEALTH.CONNECTIVITY_STATUS.TOOLTIP.NO_SIGNALS');
    const lastSignal = this.translateService.instant('SYSTEM_HEALTH.CONNECTIVITY_STATUS.TOOLTIP.LAST_SIGNAL');
    const dataReceived = this.translateService.instant('SYSTEM_HEALTH.CONNECTIVITY_STATUS.TOOLTIP.DATA_RECEIVED');

    const connectivity = this.connectivity();
    if (connectivity === undefined) {
      return '';
    }

    const timeString =
      connectivity.signalStatus.lastSignal.toString() == '0001-01-01T00:00:00'
        ? noSignals
        : connectivity.signalStatus.lastSignal.toLocaleString(undefined, options);

    return `${lastSignal}: ${timeString} 
            ${dataReceived}: ${connectivity.signalStatus.receivedPercentage.toFixed(2)}%`;
  });
}
